import React, { useEffect, useState } from "react";
import VizSensor from "react-visibility-sensor";

const ViewTriggerSensor = ({ onViewTrigger, intervalDelay, children }) => {
  const [sensorActive, setSensorActive] = useState(true);
  const [viewTriggered, setViewTriggered] = useState(false);

  useEffect(() => {
    function handleDocumentFocus() {
      setSensorActive(true);
    }
    function handleDocumentBlur() {
      setSensorActive(false);
    }

    window.addEventListener("focus", handleDocumentFocus);
    window.addEventListener("blur", handleDocumentBlur);

    return () => {
      window.removeEventListener("focus", handleDocumentFocus);
      window.removeEventListener("blur", handleDocumentBlur);
    };
  }, []);

  return (
    <VizSensor
      intervalDelay={intervalDelay ? intervalDelay : 500}
      onChange={(isVisible) => {
        if (!viewTriggered && isVisible) {
          setViewTriggered(true);
          setSensorActive(false);
          onViewTrigger();
        }
      }}
      active={sensorActive}
      children={children}
    />
  );
};

export default ViewTriggerSensor;
